// extracted by mini-css-extract-plugin
module.exports = {"mobileNav":"MobileHeader_mobileNav__Vj2Q9","expand":"MobileHeader_expand__qpZ9M","collapse":"MobileHeader_collapse__NGzFx","mobileNavHeader":"MobileHeader_mobileNavHeader__tSRdb"};